import { Icon, Paper, Typography } from '@sanlam-glacier/app-common/components';
import styles from './empty-data.module.css';

type EmptyDataProps = {
  searchTerm?: string;
};

export const EmptyData = ({ searchTerm }: EmptyDataProps) => {
  return (
    <Paper
      color={Paper.COLOR.GLASS_DARK}
      variant={Paper.VARIANT.DEFAULT}
      selectable={false}
      className={styles.emptyDataTopPadding}
    >
      <div className={styles.dataWrapper}>
        <Typography
          variant={Typography.VARIANT.H3}
          align={Typography.ALIGN.CENTER}
          color={Typography.COLOR.TERTIARY}
        >
          <Icon icon='action_youtube-searched-for' />
        </Typography>
        <Typography
          variant={Typography.VARIANT.B1}
          align={Typography.ALIGN.CENTER}
          color={Typography.COLOR.TERTIARY}
        >
          {searchTerm
            ? `We are unable to find a result for "${searchTerm}".`
            : ' You do not have any proposals'}
        </Typography>
        <br />
        <Typography
          variant={Typography.VARIANT.B3}
          align={Typography.ALIGN.CENTER}
          color={Typography.COLOR.TERTIARY}
        >
          {searchTerm && <>Please try another search.</>}
        </Typography>
      </div>
    </Paper>
  );
};
